export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_04.c5c3a54c.mp4";